/**
 * Plantillas predefinidas para componentes de frigoríficos
 * Estos son los valores por defecto que el cliente cargará
 */

export const PLANTILLAS = {
  GABINETE: {
    nombre: "Gabinete Estándar",
    tipo: "Gabinete",
    campos: {
      frente: 0,
      profundidad: 0,
      altura: 0,
      material: "Acero Inoxidable",
      aislamiento: 100,
    },
    panels: [
      { nombre: "Panel Frontal", cantidad: 1, costo: 0 },
      { nombre: "Panel Lateral", cantidad: 2, costo: 0 },
      { nombre: "Panel Superior", cantidad: 1, costo: 0 },
      { nombre: "Panel Inferior", cantidad: 1, costo: 0 },
    ],
  },

  PUERTA: {
    nombre: "Puerta Estándar",
    tipo: "Puerta",
    campos: {
      tipo: "Abatible",
      ancho: 0,
      alto: 0,
    },
    items: [
      { nombre: "Conjunto manijas", cantidad: 1, costo: 0 },
      { nombre: "Bisagras", cantidad: 2, costo: 0 },
      { nombre: "Vuelvo J", cantidad: 6, costo: 0 },
      { nombre: "Madera", cantidad: 6, costo: 0 },
      { nombre: "Pegamento", cantidad: 1, costo: 0 },
      { nombre: "Chapa U", cantidad: 1, costo: 0 },
      { nombre: "Tirafondo 14x50 c/hexagonal", cantidad: 16, costo: 0 },
      { nombre: "Tornillos auto 1/4 x 1/2'", cantidad: 16, costo: 0 },
      { nombre: "Arandela 1x4", cantidad: 16, costo: 0 },
      { nombre: "Tirafondo 14x50 c/frezada", cantidad: 4, costo: 0 },
    ],
  },

  ACCESORIO: {
    nombre: "Accesorio Estándar",
    tipo: "Accesorio",
    campos: {
      descripcion: "",
    },
    items: [
      { nombre: "Tarugos del 8", cantidad: 30, costo: 0 },
      { nombre: "Tirafondo del 8", cantidad: 30, costo: 0 },
      { nombre: "Tornillos T1", cantidad: 200, costo: 0 },
      { nombre: "Zócalo sanitario", cantidad: 20, costo: 0 },
      { nombre: "Silicona", cantidad: 6, costo: 0 },
    ],
  },

  MATERIALES_FRIO: {
    nombre: "Materiales de Frío Estándar",
    tipo: "MaterialeFrio",
    campos: {
      tipo: "Refrigerante",
    },
    items: [
      { nombre: "D líquido caño 3/8", cantidad: 4, costo: 0 },
      { nombre: "D succión caño 5/8", cantidad: 4, costo: 0 },
      { nombre: "Funda 3/8", cantidad: 4, costo: 0 },
      { nombre: "Funda 5/8", cantidad: 4, costo: 0 },
      { nombre: "Capilar 1.50", cantidad: 6, costo: 0 },
      { nombre: "Válvula expansora R22", cantidad: 1, costo: 0 },
      { nombre: "Tobera número 3", cantidad: 1, costo: 0 },
      { nombre: "Filtro molecular 3/8", cantidad: 1, costo: 0 },
      { nombre: "Gas", cantidad: 2, costo: 0 },
    ],
  },

  MATERIALES_ELECTRICOS: {
    nombre: "Materiales Eléctricos Estándar",
    tipo: "MaterialeElectrico",
    campos: {
      tipo: "Cable",
    },
    items: [
      { nombre: "Cable 5 x 2.5", cantidad: 8, costo: 0 },
      { nombre: "Cable 3 x 1.5", cantidad: 8, costo: 0 },
      { nombre: "Listón estanco plafon", cantidad: 1, costo: 0 },
      { nombre: "Tubo led 18w", cantidad: 1, costo: 0 },
      { nombre: "Caja de paso 166 x 122 x 110", cantidad: 1, costo: 0 },
      { nombre: "Caja pvc PR 409 Rocket", cantidad: 1, costo: 0 },
      { nombre: "Térmica 2 x 20 amp", cantidad: 1, costo: 0 },
      { nombre: "Relevo térmico 9 - 13", cantidad: 1, costo: 0 },
      { nombre: "Combistato EK 30 - 20", cantidad: 1, costo: 0 },
    ],
  },

  UNIDAD_CONDENSADORA: {
    nombre: "Unidad Condensadora Estándar",
    tipo: "UnidadCondensadora",
    campos: {
      modelo: "",
      potencia: 0,
    },
    items: [
      { nombre: "Compresor", cantidad: 1, costo: 0 },
      { nombre: "Condensador", cantidad: 1, costo: 0 },
      { nombre: "Ventilador", cantidad: 1, costo: 0 },
    ],
  },

  EVAPORADOR_CUBICO: {
    nombre: "Evaporador Cúbico Estándar",
    tipo: "EvaporadorCubico",
    campos: {
      modelo: "",
      potencia: 0,
    },
    items: [
      { nombre: "Evaporador", cantidad: 1, costo: 0 },
      { nombre: "Motor", cantidad: 1, costo: 0 },
      { nombre: "Aletas", cantidad: 1, costo: 0 },
    ],
  },
};

export const getPlantilla = (tipo) => {
  if (!tipo) return null;
  // Normalizar entrada: pasar a minúsculas y eliminar caracteres no alfanuméricos
  const norm = String(tipo).toLowerCase().replace(/[^a-z0-9]/g, "");

  // Buscar por clave directa (mayúsculas) o por clave normalizada
  for (const key of Object.keys(PLANTILLAS)) {
    if (key === tipo.toUpperCase()) return PLANTILLAS[key];
    const keyNorm = key.toLowerCase().replace(/[^a-z0-9]/g, "");
    if (keyNorm === norm) return PLANTILLAS[key];
  }

  return null;
};

// Utility: ensure a value is returned as an array. If it's an object-like map, return its values.
export const ensureArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  // If it's an object with numeric keys or a map, convert to values
  if (typeof val === 'object') return Object.values(val);
  // otherwise, wrap primitive into array
  return [val];
};

// Better getter that returns a normalized plantilla (items/panels coerced to arrays)
export const getPlantillaNormalized = (tipo) => {
  const p = getPlantilla(tipo);
  if (!p) return null;
  const copy = { ...p };
  // normalize both items and panels into `items`
  copy.items = ensureArray(p.items || p.panels || []);
  copy.panels = ensureArray(p.panels || p.items || []);
  return copy;
};

export const getPalabrasClaveComponente = (tipo) => {
  const palabrasClaves = {
    gabinete: ["gabinete", "frente", "profundidad", "altura", "panel"],
    puerta: ["puerta", "ancho", "alto", "tipo", "abatible"],
    accesorio: ["accesorio", "descripcion"],
    materialefrio: ["material", "frio", "refrigerante", "r404"],
    materialeelectrico: ["cable", "electrico", "breaker"],
    unidadcondensadora: ["unidad", "condensadora", "compresor"],
    evaporadorcubico: ["evaporador", "cubico", "motor", "potencia"],
  };
  return palabrasClaves[tipo.toLowerCase()] || [];
};
